import { Link } from "react-router-dom";
import { Mark } from "./Mark";
import { NavLink, NAV_LINKS } from "./Nav";
import { CONTACT_EMAIL, mailto } from "../../content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0B1118] border-t border-[#B59A5B]/20">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-12">
      <div className="md:col-span-5">
        <div className="flex items-center gap-3 text-[#C9AD6A]">
          <Mark className="w-9 h-9" />
          <span className="font-display tracking-[0.3em] text-[#FAF6ED]">10THCELESTIAL</span>
        </div>
        <p className="mt-4 font-display italic text-lg text-[#FAF6ED]/75">Where Intuition Meets Intention.</p>
      </div>
      <div className="md:col-span-3 flex md:flex-col gap-5 font-caps text-xs tracking-[0.22em] uppercase text-[#FAF6ED]/80">
        {NAV_LINKS.map((l) => (
          <NavLink key={l.id} id={l.id} label={l.label} testid={`footer-link-${l.id}`} className="hover:text-[#E2CC92] transition-colors w-fit" />
        ))}
      </div>
      <div className="md:col-span-4">
        <a href={mailto()} data-testid="footer-email-link" className="text-[#E2CC92] font-body link-underline break-all">{CONTACT_EMAIL}</a>
        <p data-testid="footer-privacy" className="mt-4 text-xs leading-relaxed text-[#FAF6ED]/65 font-body">
          Astrological interpretation is offered as a reflective, symbolic framework, distinct from evidence-based business guidance.
        </p>
        <Link to="/privacy" data-testid="footer-privacy-link" className="mt-4 inline-block font-caps text-xs tracking-[0.22em] uppercase text-[#E2CC92] link-underline">
          Privacy &amp; Confidentiality Notice
        </Link>
      </div>
    </div>
    <div className="border-t border-[#FAF6ED]/10">
      <p className="mx-auto max-w-7xl px-5 sm:px-8 py-6 text-xs text-[#FAF6ED]/60 font-body">© {new Date().getFullYear()} 10THCELESTIAL. All rights reserved.</p>
    </div>
  </footer>
);
